(function () {
  'use strict';

  var MENU_SELECTOR = '[data-mobile-menu]';
  var ACC_TRIGGER = '[data-mm-acc-trigger]';
  var DRILL_TRIGGER = '[data-mm-drill-trigger]';
  var DRILL_BACK = '[data-mm-drill-back]';
  var ACC_ITEM = '[data-mm-acc-item]';
  var DRILL_ITEM = '[data-mm-drill-item]';
  var DRILL_GROUP = '[data-mm-drill-group]';
  var DRILL_PANEL = '.mm-drill__panel';

  function getMenuRoot(el) {
    return el.closest(MENU_SELECTOR);
  }

  function getAccordionPanel(trigger) {
    var panelId = trigger.getAttribute('aria-controls');
    return panelId ? document.getElementById(panelId) : trigger.nextElementSibling;
  }

  function getDrillPanel(trigger) {
    if (!trigger) return null;

    var panelId = trigger.getAttribute('aria-controls');
    if (panelId) {
      return document.getElementById(panelId);
    }

    var item = trigger.closest(DRILL_ITEM);
    return item ? item.querySelector(DRILL_PANEL) : null;
  }

  function setPanelOpen(panel, open) {
    if (!panel) return;
    panel.hidden = !open;
  }

  function setDrillOpen(panel, open) {
    if (!panel) return;
    panel.classList.toggle('is-open', open);
    panel.setAttribute('aria-hidden', open ? 'false' : 'true');

    if (open) {
      panel.removeAttribute('inert');
    } else {
      panel.setAttribute('inert', '');
    }

    updateDrillOpenState(getMenuRoot(panel));
  }

  function updateDrillOpenState(menu) {
    if (!menu) return;
    var hasOpen = menu.querySelector(DRILL_PANEL + '.is-open');
    menu.classList.toggle('has-mm-drill-open', !!hasOpen);
  }

  function getDrillItemForPanel(panel, menu) {
    if (!panel || !menu) return null;

    var trigger = panel.id ? menu.querySelector('[aria-controls="' + panel.id + '"]') : null;
    return trigger ? trigger.closest(DRILL_ITEM) : null;
  }

  function getDrillGroupForPanel(panel, menu) {
    if (!panel || !menu) return null;

    var trigger = panel.id ? menu.querySelector('[aria-controls="' + panel.id + '"]') : null;
    return trigger ? trigger.closest(DRILL_GROUP) : null;
  }

  function setHeaderHeightVar(menu) {
    if (!menu) return;

    var header = menu.querySelector('.mobile-menu__item--header');
    if (header) {
      menu.style.setProperty('--mm-header-h', header.offsetHeight + 'px');
    }
  }

  function closeAccordionItem(item) {
    if (!item) return;

    var trigger = item.querySelector(ACC_TRIGGER);
    var panel = trigger ? getAccordionPanel(trigger) : item.querySelector('.mm-acc__panel');

    item.classList.remove('is-open');
    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }
    setPanelOpen(panel, false);
    resetDrillGroup(panel);
  }

  function openAccordionItem(item) {
    var trigger = item.querySelector(ACC_TRIGGER);
    var panel = getAccordionPanel(trigger);

    item.classList.add('is-open');
    trigger.setAttribute('aria-expanded', 'true');
    setPanelOpen(panel, true);
  }

  function closeSiblingAccordions(item) {
    var menu = getMenuRoot(item);
    if (!menu) return;

    menu.querySelectorAll(ACC_ITEM + '.is-open').forEach(function (openItem) {
      if (openItem !== item) {
        closeAccordionItem(openItem);
      }
    });
  }

  function resetDrillGroup(container) {
    if (!container) return;

    container.querySelectorAll(DRILL_GROUP + '.is-drilled').forEach(function (group) {
      group.classList.remove('is-drilled');
    });

    container.querySelectorAll(DRILL_ITEM + '.is-drilled').forEach(function (item) {
      item.classList.remove('is-drilled');
      var trigger = item.querySelector(DRILL_TRIGGER);
      var panel = getDrillPanel(trigger);
      if (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      }
      setDrillOpen(panel, false);
    });

    container.querySelectorAll(DRILL_PANEL + '.is-open').forEach(function (panel) {
      setDrillOpen(panel, false);
    });
  }

  function resetMenu(menu) {
    if (!menu) return;

    menu.querySelectorAll(ACC_ITEM + '.is-open').forEach(closeAccordionItem);
    resetDrillGroup(menu);
    updateDrillOpenState(menu);
  }

  function handleAccordionTrigger(trigger) {
    var item = trigger.closest(ACC_ITEM);
    if (!item) return;

    var isOpen = item.classList.contains('is-open');

    if (isOpen) {
      closeAccordionItem(item);
      return;
    }

    closeSiblingAccordions(item);
    openAccordionItem(item);
  }

  function handleDrillTrigger(trigger) {
    var menu = getMenuRoot(trigger);
    var item = trigger.closest(DRILL_ITEM);
    var group = trigger.closest(DRILL_GROUP);
    if (!item || !group) return;

    setHeaderHeightVar(menu);

    group.querySelectorAll(DRILL_ITEM + '.is-drilled').forEach(function (drilledItem) {
      if (drilledItem !== item) {
        drilledItem.classList.remove('is-drilled');
        var drilledTrigger = drilledItem.querySelector(DRILL_TRIGGER);
        var drilledPanel = getDrillPanel(drilledTrigger);
        if (drilledTrigger) {
          drilledTrigger.setAttribute('aria-expanded', 'false');
        }
        setDrillOpen(drilledPanel, false);
      }
    });

    group.classList.add('is-drilled');
    item.classList.add('is-drilled');
    trigger.setAttribute('aria-expanded', 'true');
    setDrillOpen(getDrillPanel(trigger), true);
  }

  function handleDrillBack(backButton) {
    var menu = getMenuRoot(backButton);
    var panel = backButton.closest(DRILL_PANEL);
    var item = backButton.closest(DRILL_ITEM) || getDrillItemForPanel(panel, menu);
    var group = backButton.closest(DRILL_GROUP) || getDrillGroupForPanel(panel, menu);
    if (!item || !group) return;

    var trigger = item.querySelector(DRILL_TRIGGER);

    item.classList.remove('is-drilled');
    group.classList.remove('is-drilled');

    if (trigger) {
      trigger.setAttribute('aria-expanded', 'false');
    }

    setDrillOpen(panel || getDrillPanel(trigger), false);
  }

  function handleClick(event) {
    var target = event.target.closest(ACC_TRIGGER + ', ' + DRILL_TRIGGER + ', ' + DRILL_BACK);
    if (!target || !getMenuRoot(target)) return;

    event.preventDefault();

    if (target.matches(ACC_TRIGGER)) {
      handleAccordionTrigger(target);
    } else if (target.matches(DRILL_TRIGGER)) {
      handleDrillTrigger(target);
    } else if (target.matches(DRILL_BACK)) {
      handleDrillBack(target);
    }
  }

  var lockedScrollY = 0;
  var pageScrollLocked = false;

  function lockPageScroll() {
    if (pageScrollLocked) return;

    lockedScrollY = window.scrollY || window.pageYOffset || 0;
    pageScrollLocked = true;
    document.documentElement.classList.add('mm-page-locked');
    document.body.classList.add('mm-page-locked');
    document.body.style.top = '-' + lockedScrollY + 'px';
  }

  function unlockPageScroll() {
    if (!pageScrollLocked) return;

    document.documentElement.classList.remove('mm-page-locked');
    document.body.classList.remove('mm-page-locked');
    document.body.style.top = '';
    window.scrollTo(0, lockedScrollY);
    pageScrollLocked = false;
  }

  function observeMenuClose() {
    document.querySelectorAll(MENU_SELECTOR).forEach(function (menu) {
      if (menu.dataset.mmAccInit === 'true') return;
      menu.dataset.mmAccInit = 'true';

      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          if (mutation.attributeName !== 'class') return;
          if (menu.classList.contains('active')) {
            setHeaderHeightVar(menu);
            lockPageScroll();
          } else {
            resetMenu(menu);
            unlockPageScroll();
          }
        });
      });

      observer.observe(menu, { attributes: true, attributeFilter: ['class'] });
    });
  }

  document.addEventListener('click', handleClick);
  document.addEventListener('DOMContentLoaded', observeMenuClose);
  observeMenuClose();
})();
